import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import {checkNegativeValues} from '../../../common/util/fieldsValidation';

class SendButton extends Component {
  constructor(props) {
    super(props);
    this.handleSaveClick = this.handleSaveClick.bind(this);
  }

  handleSaveClick() {
    const {configuration} = this.props;
    const newConfiguration = configuration.map((element) => {
      return !element.days ? {...element, 'days': 0} : element;
    });
    const configurationDays = newConfiguration.map((element) => element.days);

    if (checkNegativeValues(configurationDays)) {
      this.props.addMessageBoxWarning(
        'Por favor revise los valores ingresados.'
      );
      return;
    }

    this.props.saveProviderOrderTrackingConfig(configuration);
  }

  render() {
    const {loading, disabled} = this.props;

    return (
      <Button
        primary
        content='GUARDAR'
        loading={loading}
        disabled={disabled || loading}
        onClick={this.handleSaveClick}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.providerOrderTrackingConfig.loading,
    'configuration': state.providerOrderTrackingConfig.configuration,
  };
};

const {addMessageBoxWarning, saveProviderOrderTrackingConfig} = Actions;

export default connect(mapStateToProps, {
  addMessageBoxWarning,
  saveProviderOrderTrackingConfig,
})(SendButton);
